import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8rgv5suw2a: FaireBrandEntity = {
  token: "b_8rgv5suw2a",
  type: "brand",
  name: "Portrait Coffee",
  avatarUrl:
    "https://cdn.faire.com/fastly/c71dcc79f740c53fb9d0d0422562005a0876479bed09d734445af689a4ebf15b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/81df4a2dd3817edb9d41515083b9e0f0f499ce205ee7d4370f082c53a7c81901.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c71dcc79f740c53fb9d0d0422562005a0876479bed09d734445af689a4ebf15b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/81df4a2dd3817edb9d41515083b9e0f0f499ce205ee7d4370f082c53a7c81901.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Portrait Coffee is a Black-owned specialty coffee roastery in West End Atlanta. We exist to change the picture that comes to mind when folks think of specialty coffee. We want a picture that includes Black people, because coffee was theirs from the beginning.\n\nCoffee was first discovered by Africans. They had no idea this drink would one day become the world's most consumed beverage, second only to water. On the flip side, they had no idea their faces would be forgotten, even as the pigment of the cup mirrored their own.\n\nFounded in 2019, we roast small-batch single origins and signature blends for cafes, boutiques, bookstores, hotels, and gift retailers across the country. Roasted to order, shipped fresh.\n\nOur wholesale program is built around:\n\nSignature blends named for Black cultural icons: Toni Morrison, Stacey Abrams, Barry Jenkins, Outkast\nRotating single origins from Colombia, Honduras, Rwanda, and beyond\nLimited-edition cultural collaborations, including the Outkast Stankonia 25th anniversary release\nBranded merchandise: ceramics, candles, apparel\nCase packs and bulk in 12 oz, 2 lb, and 5 lb for cafes, restaurants, and office programs\n\nBlack-owned. Atlanta-based. Specialty grade. Roasted to order.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.988Z",
    importedBy: "entity-db-cli",
  },
};
